import { Component } from '@angular/core';

@Component({
  selector: 'app-input-listbox-loader',
  template: `
    <div class="overlay-loader position-relative mh-200px">
      <div class="my-3 d-flex align-items-center gap-4" *ngFor="let i of [0, 1, 2]">
        <div class="col-auto">
          <app-skeleton-text [type]="'icon'" [width]="25" [height]="25"></app-skeleton-text>
        </div>
        <div class="col">
          <app-skeleton-text [fluidSize]="true" [type]="'text'"></app-skeleton-text>
        </div>
      </div>
    </div>
  `,
})
export class InputListboxLoaderComponent {}
